import _default from './TransitionablePortal';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/addons/TransitionablePortal/index.js
// module id = 2685
// module chunks = 1